import CookiePolicy from './cookie-policy.js';

export default {
    init() {
        $.fn['cookie-policy'] = function() {
            return this.each((i, el) => {
                let cookiePolicy = new CookiePolicy($(el));
                cookiePolicy.init();
            });
        };

        $('[data-cookie-policy]')['cookie-policy']();
    }
};
